import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { applicationUrls } from 'sharedweb/helpers/urls';
import { FIREBASE_FETCH_TIMEOUT, Utils } from 'src/app/_helpers';
import { REST_BUILD } from 'src/app/_helpers/configuration';
import { RemoteConfigCacheObj, RemoteConfigUrlResponse } from 'src/app/app.interfaces';
import { ConfigurationKeys } from 'src/app/app.structs';
import * as firebase from 'firebase/app';
import { fetchAndActivate, getRemoteConfig, RemoteConfig, getAll } from 'firebase/remote-config';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  remoteConfigCacheObj: RemoteConfigCacheObj = {} as any;
  environmentFileRequest: Promise<Object>;
  environmentFile: Object;

  constructor(
    private http: HttpClient
  ) { }

  // Loads configurations required at initialization of application.
  initFirebaseConfig() {
    return new Promise<void>((resolve, reject) => {
      this.getEnvironmentFile().then(config => {
        if (config?.hasOwnProperty('firebase')) {
          try {
            firebase.initializeApp(config['firebase']);
            const remoteConfig = getRemoteConfig();
            remoteConfig.settings.minimumFetchIntervalMillis = FIREBASE_FETCH_TIMEOUT;
            this.loadConfig(resolve, remoteConfig);
          } catch (err) {
            console.log('Error initializing firebase', err);
            resolve();
          }
        } else {
          console.log('Firebase config not found in env.json');
          resolve();
        }
      }).catch((err) => {
        console.log('Error fetching firebase config', err);
        resolve();
      });
    });
  }

  getEnvironmentFile() { 
    if (this.environmentFile === undefined) { 
      if (this.environmentFileRequest) { 
        return this.environmentFileRequest; 
      } else {
        this.environmentFileRequest = new Promise((resolve, reject) => {
          this.http.get('/assets/env/env.json').subscribe(config => {
            this.environmentFile = config;
            resolve(config);
          },(err) => {
            reject(err);
          });
        });
        return this.environmentFileRequest;
      }
    } else {
      return Promise.resolve(this.environmentFile);
    }
  }

  handleUrls(value: string) {
    if (value?.length) {
      const urls: RemoteConfigUrlResponse = JSON.parse(value);

      if (!REST_BUILD) {
        applicationUrls.rootUrl = urls?.rootUrl?.length ? urls?.rootUrl : applicationUrls.rootUrl;
        applicationUrls.serverUrl = urls?.serverUrl?.length ? urls?.serverUrl : applicationUrls.serverUrl;
        applicationUrls.serverUrlMarket = urls?.socketUrl?.length ? urls?.socketUrl : applicationUrls.serverUrlMarket;
        applicationUrls.serverUrlChart = urls?.chartSocketUrl?.length ? urls?.chartSocketUrl : applicationUrls.serverUrlChart;
        applicationUrls.edisServerUrl = urls?.edisServerUrl?.length ? urls?.edisServerUrl : applicationUrls.edisServerUrl;
        applicationUrls.analyticsServerUrl = urls?.analyticsServerUrl?.length ? urls?.analyticsServerUrl : applicationUrls.analyticsServerUrl;
      } else {
        applicationUrls.restServerUrl = urls?.restServerUrl?.length ? urls?.restServerUrl : applicationUrls.restServerUrl;
      }
    }
  }


  loadConfig(resolve: Function, remotConfig: RemoteConfig) {
    fetchAndActivate(remotConfig).then((_) => {
      try {
        const values = getAll(remotConfig) as any;
        if (values && Object.keys(values).length) {
          this.handleUrls(values[REST_BUILD ? ConfigurationKeys.RestUrls : ConfigurationKeys.RetailUrls]?._value);


          Object.keys(values).forEach((key) => {
            if (Utils.isJson(values[key]._value)) {
              this.remoteConfigCacheObj[key] = JSON.parse(values[key]._value);
            } else {
              this.remoteConfigCacheObj[key] = values[key]._value;
            }
          });
        }
        resolve();
      } catch(err)  {
        console.log(`Error fetching firebase params, err: ${err}`);
        // Need to resolve on error as application need to resume even after urls are not fetched.
        resolve();
      }
    }).catch((err) => {
      console.log(`Error activating firebase remote config, err: ${err}`);
      // Need to resolve on error as application need to resume even after urls are not fetched.
      resolve();
    });
  }

}
